<template>
  <pt-pt-feedback-detail class="pt-pt-feedback-detail__page"></pt-pt-feedback-detail>
</template>

<script>
import PtPtFeedbackDetail from 'cps/other-service/pt-feedback-manage/pt-pt-feedback-detail/withData'
export default {
  name: 'pt-pt-feedback-detail__view',
  components: {
    'pt-pt-feedback-detail': PtPtFeedbackDetail
  }
}
</script>
